var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { RouterProvider, createBrowserRouter, Outlet, Link, Navigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import RoutesConfig from '../routes/RoutesConfig';
import RouteWrapper from "../routes/Route";
import Login from './pages/Login/Login';
import ForgotPassword from './pages/ForgotPassword/ForgotPassword';
import ResetPassword from './pages/ResetPassword/ResetPassword';
import CreateAccount from './pages/CreateAccount/CreateAccount';
import ConfirmRegistration from './pages/ConfirmRegistration/ConfirmRegistration';
import AcceptInvitation from './pages/AcceptInvitation/AcceptInvitation';
import OnBoarding from './pages/OnBoarding/OnBoarding';
import Users from './pages/Users/Users';
import Assets from './pages/Assets/Assets';
import AssetArchive from './pages/AssetArchive/AssetArchive';
import Feeds from './pages/Feeds/Feeds';
import Feed from './pages/Feeds/Feed';
import Devices from './pages/Devices/Devices';
import ServiceSchemas from './pages/ServiceSchemas/ServiceSchemas';
import AssetDetail from './pages/Assets/AssetDetail';
import ServiceEntries from './pages/ServiceEntries/ServiceEntries';
import ClosedServiceEntries from './pages/ServiceEntries/ClosedServiceEntries';
import Reports from './pages/Reports/Reports';
import Metrics from "./pages/Metrics/Metrics";
import Labels from './pages/Labels/Labels';
import Loading from './pages/Loading';
import MainNavigation from './components/ui/MainNavigation/MainNavigation';
import LoadingScreen from './components/ui/LoadingScreen/LoadingScreen';
import Notifications from './components/ui/Notifications/Notifications';
import AlertModal from './components/ui/Modals/AlertModal';
import ConfirmModal from './components/ui/Modals/ConfirmModal';
import Overlay from './components/ui/Overlay/Overlay';
import { FormattedMessage } from "react-intl";
import { Breadcrumb, BreadcrumbItem } from "reactstrap";
import ServiceSchemaOverlay from "./pages/ServiceSchemas/ServiceSchemaOverlay";
import UnregisterUser from "./pages/DeleteAccount/UnregisterUser";
/**
 *
 */
var Views = /** @class */ (function (_super) {
    __extends(Views, _super);
    /**
     *
     */
    function Views(props) {
        return _super.call(this, props) || this;
    }
    /**
     *
     */
    Views.prototype.componentDidMount = function () {
    };
    /**
     *
     */
    Views.prototype.render = function () {
        var router = createBrowserRouter([
            {
                element: (React.createElement("div", { className: "main-content" },
                    React.createElement("div", { className: "page" },
                        React.createElement(MainNavigation, null),
                        React.createElement(Outlet, null)),
                    React.createElement("div", null,
                        React.createElement(AssetDetail, null),
                        React.createElement(Overlay, null),
                        React.createElement(Notifications, null),
                        React.createElement(AlertModal, null),
                        React.createElement(ConfirmModal, null),
                        React.createElement(LoadingScreen, null)))),
                children: [
                    {
                        path: RoutesConfig.ROOT.path,
                        element: React.createElement(RouteWrapper, { isInitial: true, path: RoutesConfig.ROOT.path },
                            React.createElement(Loading, null))
                    },
                    {
                        path: RoutesConfig.LOGIN.path,
                        element: React.createElement(RouteWrapper, { path: RoutesConfig.LOGIN.path },
                            React.createElement(Login, null))
                    },
                    {
                        path: RoutesConfig.CREATE_ACCOUNT.path,
                        element: React.createElement(RouteWrapper, { path: RoutesConfig.CREATE_ACCOUNT.path },
                            React.createElement(CreateAccount, null))
                    },
                    {
                        path: RoutesConfig.DELETE_ACCOUNT.path,
                        element: React.createElement(RouteWrapper, { isPrivate: true, path: RoutesConfig.DELETE_ACCOUNT.path },
                            React.createElement(UnregisterUser, null))
                    },
                    {
                        path: RoutesConfig.CONFIRM_REGISTRATION.path,
                        element: React.createElement(RouteWrapper, { path: RoutesConfig.CONFIRM_REGISTRATION.path },
                            React.createElement(ConfirmRegistration, null))
                    },
                    {
                        path: RoutesConfig.ACCEPT_INVITE.path,
                        element: React.createElement(RouteWrapper, { path: RoutesConfig.ACCEPT_INVITE.path },
                            React.createElement(AcceptInvitation, null))
                    },
                    {
                        path: RoutesConfig.FORGOT_PASSWORD.path,
                        element: React.createElement(RouteWrapper, { path: RoutesConfig.FORGOT_PASSWORD.path },
                            React.createElement(ForgotPassword, null))
                    },
                    {
                        path: RoutesConfig.RESET_PASSWORD.path,
                        element: React.createElement(RouteWrapper, { path: RoutesConfig.RESET_PASSWORD.path },
                            React.createElement(ResetPassword, null))
                    },
                    {
                        path: RoutesConfig.ON_BOARDING.path,
                        element: React.createElement(RouteWrapper, { path: RoutesConfig.ON_BOARDING.path, isPrivate: true },
                            React.createElement(OnBoarding, null))
                    },
                    {
                        path: RoutesConfig.DASHBOARD.path,
                        element: React.createElement(RouteWrapper, { path: RoutesConfig.DASHBOARD.path, isPrivate: true },
                            React.createElement(Navigate, { to: RoutesConfig.ROOT.path }),
                            ";")
                    },
                    {
                        path: RoutesConfig.ASSETS.path,
                        element: React.createElement(RouteWrapper, { isPrivate: true, path: RoutesConfig.ASSETS.path },
                            React.createElement(Assets, null)),
                        handle: {
                            crumb: function () { return React.createElement(Breadcrumb, null,
                                React.createElement(BreadcrumbItem, { active: true },
                                    React.createElement(FormattedMessage, { id: "page.assets.title" }))); }
                        }
                    },
                    {
                        path: RoutesConfig.ASSETS_ARCHIVED.path,
                        element: React.createElement(RouteWrapper, { isPrivate: true, path: RoutesConfig.ASSETS_ARCHIVED.path },
                            React.createElement(AssetArchive, null)),
                        handle: {
                            crumb: function () { return React.createElement(Breadcrumb, null,
                                React.createElement(BreadcrumbItem, null,
                                    React.createElement(Link, { to: RoutesConfig.ASSETS.getPath() },
                                        React.createElement(FormattedMessage, { id: "page.assets.title" }))),
                                React.createElement(BreadcrumbItem, { active: true },
                                    React.createElement(FormattedMessage, { id: "page.assets.archive.title" }))); }
                        }
                    },
                    {
                        path: RoutesConfig.LABELS.path,
                        element: React.createElement(RouteWrapper, { isPrivate: true, path: RoutesConfig.LABELS.path },
                            React.createElement(Labels, null))
                    },
                    {
                        path: RoutesConfig.USERS.path,
                        element: React.createElement(RouteWrapper, { isPrivate: true, path: RoutesConfig.USERS.path },
                            React.createElement(Users, null)),
                        handle: {
                            crumb: function () { return React.createElement(Breadcrumb, null,
                                React.createElement(BreadcrumbItem, null,
                                    React.createElement(Link, { to: RoutesConfig.ASSETS.getPath() },
                                        React.createElement(FormattedMessage, { id: "page.assets.title" }))),
                                React.createElement(BreadcrumbItem, { active: true },
                                    React.createElement(FormattedMessage, { id: "page.users.title" }))); }
                        }
                    },
                    {
                        path: RoutesConfig.FEEDS.path,
                        element: React.createElement(RouteWrapper, { isPrivate: true, path: RoutesConfig.FEEDS.path },
                            React.createElement(Feeds, null)),
                        handle: {
                            crumb: function () { return React.createElement(Breadcrumb, null,
                                React.createElement(BreadcrumbItem, null,
                                    React.createElement(Link, { to: RoutesConfig.ASSETS.getPath() },
                                        React.createElement(FormattedMessage, { id: "page.assets.title" }))),
                                React.createElement(BreadcrumbItem, { active: true },
                                    React.createElement(FormattedMessage, { id: "page.feeds.title" }))); }
                        }
                    },
                    {
                        path: RoutesConfig.FEEDS_ADD.path,
                        element: React.createElement(RouteWrapper, { isPrivate: true, path: RoutesConfig.FEEDS_ADD.path },
                            React.createElement(Feed, null)),
                        handle: {
                            crumb: function () { return React.createElement(Breadcrumb, null,
                                React.createElement(BreadcrumbItem, null,
                                    React.createElement(Link, { to: RoutesConfig.ASSETS.getPath() },
                                        React.createElement(FormattedMessage, { id: "page.assets.title" }))),
                                React.createElement(BreadcrumbItem, null,
                                    React.createElement(Link, { to: RoutesConfig.FEEDS.getPath() },
                                        React.createElement(FormattedMessage, { id: "page.feeds.title" }))),
                                React.createElement(BreadcrumbItem, { active: true },
                                    React.createElement(FormattedMessage, { id: "page.feed.title.add" }))); }
                        }
                    },
                    {
                        path: RoutesConfig.FEED_EDIT.path,
                        element: React.createElement(RouteWrapper, { isPrivate: true, path: RoutesConfig.FEED_EDIT.path },
                            React.createElement(Feed, null)),
                        handle: {
                            crumb: function () { return React.createElement(Breadcrumb, null,
                                React.createElement(BreadcrumbItem, null,
                                    React.createElement(Link, { to: RoutesConfig.ASSETS.getPath() },
                                        React.createElement(FormattedMessage, { id: "page.assets.title" }))),
                                React.createElement(BreadcrumbItem, null,
                                    React.createElement(Link, { to: RoutesConfig.FEEDS.getPath() },
                                        React.createElement(FormattedMessage, { id: "page.feeds.title" }))),
                                React.createElement(BreadcrumbItem, { active: true },
                                    React.createElement(FormattedMessage, { id: "page.feed.title.edit" }))); }
                        }
                    },
                    {
                        path: RoutesConfig.DEVICES.path,
                        element: React.createElement(RouteWrapper, { isPrivate: true, path: RoutesConfig.DEVICES.path },
                            React.createElement(Devices, null)),
                        handle: {
                            crumb: function () { return React.createElement(Breadcrumb, null,
                                React.createElement(BreadcrumbItem, null,
                                    React.createElement(Link, { to: RoutesConfig.ASSETS.getPath() },
                                        React.createElement(FormattedMessage, { id: "page.assets.title" }))),
                                React.createElement(BreadcrumbItem, { active: true },
                                    React.createElement(FormattedMessage, { id: "page.devices.title" }))); }
                        }
                    },
                    {
                        // This route is not used, it just links to devices page, remove it?
                        path: RoutesConfig.DEVICES_ADD.path,
                        element: React.createElement(RouteWrapper, { isPrivate: true, path: RoutesConfig.DEVICES_ADD.path },
                            React.createElement(Devices, null)),
                        handle: {
                            crumb: function () { return React.createElement(Breadcrumb, null,
                                React.createElement(BreadcrumbItem, null,
                                    React.createElement(Link, { to: RoutesConfig.ASSETS.getPath() },
                                        React.createElement(FormattedMessage, { id: "page.assets.title" }))),
                                React.createElement(BreadcrumbItem, null,
                                    React.createElement(Link, { to: RoutesConfig.DEVICES.getPath() },
                                        React.createElement(FormattedMessage, { id: "page.devices.title" }))),
                                React.createElement(BreadcrumbItem, { active: true },
                                    React.createElement(FormattedMessage, { id: "page.assets.title" }))); }
                        }
                    },
                    {
                        path: RoutesConfig.SERVICE_SCHEMAS.path,
                        element: React.createElement(RouteWrapper, { isPrivate: true, path: RoutesConfig.SERVICE_SCHEMAS.path },
                            React.createElement(ServiceSchemas, null)),
                        handle: {
                            crumb: function () { return React.createElement(Breadcrumb, null,
                                React.createElement(BreadcrumbItem, null,
                                    React.createElement(Link, { to: RoutesConfig.ASSETS.getPath() },
                                        React.createElement(FormattedMessage, { id: "page.assets.title" }))),
                                React.createElement(BreadcrumbItem, { active: true },
                                    React.createElement(FormattedMessage, { id: "page.service.schemas.title" }))); }
                        }
                    },
                    {
                        path: RoutesConfig.SERVICE_SCHEMAS_ADD.path,
                        element: React.createElement(RouteWrapper, { isPrivate: true, path: RoutesConfig.SERVICE_SCHEMAS_ADD.path },
                            React.createElement(ServiceSchemas, { overlay: 'add' })),
                        handle: {
                            crumb: function () { return React.createElement(Breadcrumb, null,
                                React.createElement(BreadcrumbItem, null,
                                    React.createElement(Link, { to: RoutesConfig.ASSETS.getPath() },
                                        React.createElement(FormattedMessage, { id: "page.assets.title" }))),
                                React.createElement(BreadcrumbItem, null,
                                    React.createElement(Link, { to: RoutesConfig.SERVICE_SCHEMAS.getPath() },
                                        React.createElement(FormattedMessage, { id: "page.service.schemas.title" })))); }
                        }
                    },
                    {
                        path: RoutesConfig.SERVICE_SCHEMAS_EDIT.path,
                        element: React.createElement(RouteWrapper, { isPrivate: true, path: RoutesConfig.SERVICE_SCHEMAS_EDIT.path },
                            React.createElement(ServiceSchemaOverlay, null)),
                        handle: {
                            crumb: function () { return React.createElement(Breadcrumb, null,
                                React.createElement(BreadcrumbItem, null,
                                    React.createElement(Link, { to: RoutesConfig.ASSETS.getPath() },
                                        React.createElement(FormattedMessage, { id: "page.assets.title" }))),
                                React.createElement(BreadcrumbItem, null,
                                    React.createElement(Link, { to: RoutesConfig.SERVICE_SCHEMAS.getPath() },
                                        React.createElement(FormattedMessage, { id: "page.service.schemas.title" }))),
                                React.createElement(BreadcrumbItem, { active: true },
                                    React.createElement(FormattedMessage, { id: "page.service.schemas.title.edit" }))); }
                        }
                    },
                    {
                        path: RoutesConfig.SERVICE_ENTRIES.path,
                        element: React.createElement(RouteWrapper, { isPrivate: true, path: RoutesConfig.SERVICE_ENTRIES.path },
                            React.createElement(ServiceEntries, null)),
                        handle: {
                            crumb: function () { return React.createElement(Breadcrumb, null,
                                React.createElement(BreadcrumbItem, null,
                                    React.createElement(Link, { to: RoutesConfig.ASSETS.getPath() },
                                        React.createElement(FormattedMessage, { id: "page.assets.title" }))),
                                React.createElement(BreadcrumbItem, { active: true },
                                    React.createElement(FormattedMessage, { id: "page.service.entries.title" }))); }
                        }
                    },
                    {
                        path: RoutesConfig.SERVICE_ENTRIES_CLOSED.path,
                        element: React.createElement(RouteWrapper, { isPrivate: true, path: RoutesConfig.SERVICE_ENTRIES_CLOSED.path },
                            React.createElement(ClosedServiceEntries, null)),
                        handle: {
                            crumb: function () { return React.createElement(Breadcrumb, null,
                                React.createElement(BreadcrumbItem, null,
                                    React.createElement(Link, { to: RoutesConfig.ASSETS.getPath() },
                                        React.createElement(FormattedMessage, { id: "page.assets.title" }))),
                                React.createElement(BreadcrumbItem, null,
                                    React.createElement(Link, { to: RoutesConfig.SERVICE_ENTRIES.getPath() },
                                        React.createElement(FormattedMessage, { id: "page.service.entries.title" }))),
                                React.createElement(BreadcrumbItem, { active: true },
                                    React.createElement(FormattedMessage, { id: "page.closed.service.entries.title" }))); }
                        }
                    },
                    {
                        path: RoutesConfig.REPORTS.path,
                        element: React.createElement(RouteWrapper, { isPrivate: true, path: RoutesConfig.REPORTS.path },
                            React.createElement(Reports, null)),
                        handle: {
                            crumb: function () { return React.createElement(Breadcrumb, null,
                                React.createElement(BreadcrumbItem, null,
                                    React.createElement(Link, { to: RoutesConfig.ASSETS.getPath() },
                                        React.createElement(FormattedMessage, { id: "page.assets.title" }))),
                                React.createElement(BreadcrumbItem, { active: true },
                                    React.createElement(FormattedMessage, { id: "page.reports.title" }))); }
                        }
                    },
                    {
                        path: RoutesConfig.METRICS.path,
                        element: React.createElement(RouteWrapper, { isPrivate: true, path: RoutesConfig.METRICS.path },
                            React.createElement(Metrics, null)),
                        handle: {
                            crumb: function () { return React.createElement(Breadcrumb, null,
                                React.createElement(BreadcrumbItem, null,
                                    React.createElement(Link, { to: RoutesConfig.ASSETS.getPath() },
                                        React.createElement(FormattedMessage, { id: "page.assets.title" }))),
                                React.createElement(BreadcrumbItem, { active: true },
                                    React.createElement(FormattedMessage, { id: "page.metrics.title" }))); }
                        }
                    }
                ]
            }
        ]);
        // Render Views
        return (React.createElement(RouterProvider, { router: router }));
    };
    Views = __decorate([
        observer
    ], Views);
    return Views;
}(React.Component));
export default Views;
// export default withRouter(Views);
